module.exports = __webpack_public_path__ + "img/javaMobile6.5db8bd1f.jpg";